// extracted by mini-css-extract-plugin
export default {"root":"IconMessage_root__e-tT3"};